import loadUnity, { type UnityInstance, type UnityMessage } from '~~/lib/unity/unity-loader.client'
import type { UnityOutgoingMessageTypes } from '~/composables/useUnityViewer'

export default defineNuxtPlugin(() => {
  const instance = shallowRef<UnityInstance | null>(null)
  const canvas: HTMLCanvasElement = document.createElement('canvas')
  canvas.setAttribute('id', 'unity-canvas')
  canvas.setAttribute('style', 'width: 100%; height: 100%; position: relative; outline: none;')
  canvas.setAttribute('tabindex', '0')
  let loading = false

  async function mount() {
    if (loading) return
    if (instance.value != null) return
    loading = true
    instance.value = await loadUnity(canvas)
    loading = false
  }

  function sendMessage(messageName: UnityOutgoingMessageTypes, message: UnityMessage) {
    instance.value?.SendMessage('ExternalMessageListenerController', messageName, JSON.stringify(message))
  }

  return {
    provide: {
      unity: {
        get instance() {
          return instance.value
        },
        canvas,
        sendMessage,
        mount,
      },
    },
  }
})
